import classNames from "classnames";
import FileUploader from "devextreme-react/file-uploader";
import React, { useMemo, useRef, useState } from "react";
import { v4 as uuid } from "uuid";
import locale from "./uploadArea.locale";
export default function UploadArea(props) {
    const id = useMemo(() => uuid(), []);
    const dropZoneElementId = useMemo(() => `dropzone-${id}`, [id]);
    const uploaderRef = useRef(null);
    const [isDropActive, setIsDropActive] = useState(false);
    const options = useMemo(() => {
        const result = {
            id: `file-uploader-${id}`,
            dialogTrigger: `#${dropZoneElementId}`,
            dropZone: `#${dropZoneElementId}`,
            multiple: false,
            uploadMode: "useButtons",
            showFileList: true,
            visible: true,
            className: "pt-0_25 pr-0_75 d-none",
            ref: uploaderRef
        };
        return result;
    }, [dropZoneElementId]);
    const handleValueChange = async (files) => {
        setIsDropActive(false);
        props.handleSaveFolder && props.handleSaveFolder(files);
    };
    const handleDropZoneEnter = (e) => e.dropZoneElement.id === dropZoneElementId && setIsDropActive(true);
    const handleDropZoneLeave = (e) => e.dropZoneElement.id === dropZoneElementId && setIsDropActive(false);
    const fileUploader = useMemo(() => (React.createElement(FileUploader, { ...options, onValueChange: handleValueChange, onDropZoneEnter: handleDropZoneEnter, onDropZoneLeave: handleDropZoneLeave })), []);
    return (React.createElement("div", { className: classNames("flex-box-centered-content h-100 border-dashed-gray border-dashed border-rounded-4 clickable", isDropActive && "bg-warning-100"), id: dropZoneElementId },
        React.createElement("div", { className: "d-flex-column flex-wrap unselectable" },
            fileUploader,
            React.createElement("div", { className: "text-light-on-surface-variant" }, locale.DROP_HERE_OR),
            React.createElement("div", { className: "text-primary-500 no-border underline-text-on-hover text-center" }, locale.SELECT_MANUALLY))));
}
